import { css } from '@emotion/react';
import { CSSInterpolation } from '@emotion/serialize';
import { RefObject, useEffect, useMemo, useRef, useState } from 'react';

type ReturnType = {
	tooltipRef: RefObject<HTMLDivElement>;
	styles: CSSInterpolation;
};

export const useSizes = (textSize: number, tooltipPosition: 'top' | 'bottom'): ReturnType => {
	const tooltipRef = useRef<HTMLDivElement>(null);
	const [containerHeight, setContainerHeight] = useState<number | null>(null);

	useEffect(() => {
		if (tooltipRef.current) {
			setContainerHeight(tooltipRef.current.clientHeight);
		}
	}, [tooltipRef, textSize]);

	const styles = useMemo(
		() =>
			css`
				${(containerHeight && `${tooltipPosition}: ${-containerHeight - 10}px`) || 'visibility: hidden'}
			`,
		[containerHeight, tooltipPosition]
	);
	return { tooltipRef, styles };
};
